function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React, { memo, useCallback } from 'react';
import { Box, Hidden, HStack, Image, Skeleton, Stack, Text, VStack } from 'native-base';
import { IconMap } from '../../atoms/IconMap';
import RenderByContentType from '../../molecules/RenderByContentType/RenderByContentType';
import uuid from 'react-native-uuid';
import Functions from '../../../../utils/Functions';
const Card = /*#__PURE__*/memo(_ref => {
  let {
    id = uuid.v4().toString(),
    metadata,
    header: {
      icon,
      title
    },
    body,
    subbody,
    callToActions
  } = _ref;
  const RenderByContentTypeCallback = useCallback(_ref2 => {
    let {
      content,
      type,
      metadata: contentMetadata,
      event
    } = _ref2;
    return /*#__PURE__*/React.createElement(RenderByContentType, {
      content: content,
      metadata: {
        ...(contentMetadata ? contentMetadata : {})
      },
      type: type,
      key: content,
      event: event
    });
  }, []);
  return /*#__PURE__*/React.createElement(Box, _extends({
    borderLeftWidth: 8,
    borderRightWidth: 1,
    borderTopWidth: 1,
    borderBottomWidth: 1,
    borderRadius: "4",
    bg: 'white.700',
    key: id,
    minH: {
      base: undefined,
      md: undefined,
      lg: 267,
      xl: 267
    }
  }, metadata ? metadata : {}, {
    testID: id,
    p: "5"
  }), /*#__PURE__*/React.createElement(VStack, {
    space: "sm",
    flex: "2"
  }, /*#__PURE__*/React.createElement(HStack, {
    space: {
      base: 3,
      sm: 3,
      md: 3,
      lg: 5
    },
    alignItems: "center"
  }, /*#__PURE__*/React.createElement(Hidden, {
    till: "lg"
  }, icon.startsWith('http') || icon.startsWith('https') ? /*#__PURE__*/React.createElement(Image, {
    w: "60",
    h: "60",
    resizeMode: "contain",
    source: {
      uri: icon
    },
    alignSelf: 'flex-start',
    fallbackElement: /*#__PURE__*/React.createElement(Skeleton, {
      w: "60",
      h: "60",
      rounded: "full"
    })
  }) : /*#__PURE__*/React.createElement(IconMap[icon], {
    width: 60,
    height: 60
  })), /*#__PURE__*/React.createElement(Text, _extends({
    flex: '1',
    fontSize: '36',
    fontWeight: 300,
    lineHeight: '42',
    color: "text.running"
  }, title.metadata ? title.metadata : {}), Functions.getTextByContent(title))), /*#__PURE__*/React.createElement(VStack, {
    ml: "3",
    flex: "1",
    space: "3"
  }, /*#__PURE__*/React.createElement(Text, null, body.map(RenderByContentTypeCallback)), !subbody ? null : RenderByContentTypeCallback(subbody)), /*#__PURE__*/React.createElement(Box, {
    alignItems: {
      base: 'flex-end'
    }
  }, /*#__PURE__*/React.createElement(Stack, {
    alignItems: {
      base: 'flex-end'
    },
    space: {
      base: 2,
      md: 2,
      lg: 6
    },
    direction: {
      sm: 'column',
      md: 'column',
      lg: 'row'
    }
  }, callToActions.map(RenderByContentTypeCallback)))));
});
export default Card;
//# sourceMappingURL=Card.js.map